import { css } from "styled-components"

export const FontFamilyRegular = css`
  font-family: "HCo Gotham", "Helvetica", "Verdana", "Arial", "sans-serif";
`

/* Mobile Styles START*/

const smh1 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 24px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const smh2 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 24px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const smh3 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 20px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const smh4 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 18px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const smh5 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 16px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const smh6 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 14px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

/* Mobile Styles END*/

/* Tablet Styles START*/

const mdh1 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 36px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const mdh2 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 24px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const mdh3 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 20px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const mdh4 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 18px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}



/* Tablet Styles END*/

/* Desktop Styles START*/

const lgh1 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 48px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 120%;
    letter-spacing: 0.05em;
  `
}

const lgh2 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 36px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const lgh3 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 30px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const lgh4 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 24px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    letter-spacing: 0.08em;
  `
}

const lgh5 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 18px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 120%;
    letter-spacing: 0.08em;
  `
}

const lgh6 = weight => {
  return css`
    ${FontFamilyRegular}
    text-transform: uppercase;
    font-size: 16px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 120%;
    letter-spacing: 0.05em;
  `
}

const lgsubheading = weight => {
  return css`
    ${FontFamilyRegular}
    font-size: 16px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 160%;
    letter-spacing: 0.05em;
  `
}

/* Desktop Styles END*/

/* Body Text START */
const bodyFeature = (weight = 400) => {
  return css`
    ${FontFamilyRegular}
    font-size: 20px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 170%;
  `
}
const bodyDefault = (weight = 400) => {
  return css`
    ${FontFamilyRegular}
    font-size: 18px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 170%;
  `
}
const bodySmall = (weight = 400) => {
  return css`
    ${FontFamilyRegular}
    font-size: 16px;
    font-style: normal;
    font-weight: ${weight};
    line-height: 170%;
  `
}
/* Body Text END */

/* Misc Styles START */
const miscLink = (weight = 500) => css`
  ${FontFamilyRegular}
  font-weight: ${weight};
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  text-decoration: none;
`
/* Misc Styles END */

export const mobileTextStyles = { smh1, smh2, smh3, smh4, smh5, smh6 }
export const tabletTextStyles = { mdh1, mdh2, mdh3, mdh4 }
export const desktopTextStyles = {
  lgh1,
  lgh2,
  lgh3,
  lgh4,
  lgh5,
  lgh6,
  lgsubheading,
}

export const T = {
  sm: {
    body: bodyDefault,
    h1: smh1,
    h2: smh2,
    h3: smh3,
    h4: smh4,
    h5: smh5,
    h6: smh6,
  },
  md: {
    body: bodySmall,
    h1: mdh1,
    h2: mdh2,
    h3: mdh3,
    h4: mdh4,
  },
  lg: {
    body: bodyDefault,
    h1: lgh1,
    h2: lgh2,
    h3: lgh3,
    h4: lgh4,
    h5: lgh5,
    h6: lgh6,
    subheading: lgsubheading,
  },
  body: {
    feature: bodyFeature,
    regular: bodyDefault,
    small: bodySmall,
  },
  misc: {
    link: miscLink,
  },
}

export default { mobileTextStyles, tabletTextStyles, desktopTextStyles }
